/** iPlan compilation layer 8 — land-use TYPE_CODE (matches XPlan renderer field1). */
export const IPLAN_COMPILATION_LAYER_ID = 8;
export const COMPILATION_TYPE_CODE_FIELD = 'TYPE_CODE';

export type CompilationLayerDefs = Record<number, string> | false;

function formatCodeLiteral(code: string): string {
  const trimmed = code.trim();
  if (/^\d+$/.test(trimmed)) {
    return trimmed;
  }
  return `'${trimmed.replace(/'/g, "''")}'`;
}

export function buildCompilationLayerDefs(
  layerId: number,
  enabledCodes: readonly string[],
  allCodes: readonly string[],
): CompilationLayerDefs {
  if (allCodes.length === 0) {
    return false;
  }
  if (enabledCodes.length === 0) {
    return { [layerId]: '1=0' };
  }
  const enabledSet = new Set(enabledCodes);
  if (allCodes.every((code) => enabledSet.has(code))) {
    return false;
  }

  const list = enabledCodes.map(formatCodeLiteral).join(',');
  return { [layerId]: `${COMPILATION_TYPE_CODE_FIELD} IN (${list})` };
}

export function isTourismDesignationLabel(label: string): boolean {
  return /תיירות|נופש|אירוח|מלון|תעסוקה תיירות/i.test(label.trim());
}
